import { Directive, TemplateRef } from '@angular/core';

import { TabDirective } from './tab.directive';

/** Should be used to mark <ng-template> element as a template for tab heading */

export class TabHeadingDirective {
  public templateRef:TemplateRef<any>;

  public constructor(templateRef:TemplateRef<any>, tab:TabDirective) {
    tab.headingRef = templateRef;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: '[tabHeading]'}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
{type: TabDirective, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
